import React from 'react';
import { Avatar } from '../../shared/Avatar';
import { MasteryBar } from '../../shared/MasteryBar';
import type { SchoolData } from './types';
interface SchoolDetailPanelProps {
  school: SchoolData;
}
export function SchoolDetailPanel({
  school
}: SchoolDetailPanelProps) {
  return <div className="space-y-6" data-id="element-7823" data-mp="3ov5s1dfuzste">
      <div className="grid grid-cols-3 gap-3" data-id="element-7824" data-mp="3oue7qyrpphif">
        <div className="bg-purple-50 rounded-lg p-3 text-center" data-id="element-7825" data-mp="3ot32euimc1p7">
          <div className="text-2xl font-bold text-purple-700" data-id="element-7826" data-mp="2s6q0jbt6v9dn">
            {school.learnerCount}
          </div>
          <div className="text-xs text-purple-600" data-id="element-7827" data-mp="2x4hra2i3kpg9">Leerlingen</div>
        </div>
        <div className="bg-indigo-50 rounded-lg p-3 text-center" data-id="element-7828" data-mp="3151r5du22763">
          <div className="text-2xl font-bold text-indigo-700" data-id="element-7829" data-mp="35x3atktjz065">
            {school.teacherCount}
          </div>
          <div className="text-xs text-indigo-600" data-id="element-7830" data-mp="29dm45iol6ifc">Docenten</div>
        </div>
        <div className="bg-emerald-50 rounded-lg p-3 text-center" data-id="element-7831" data-mp="2dg0k9v0vf42x">
          <div className="text-2xl font-bold text-emerald-700" data-id="element-7832" data-mp="2de63mswmty4n">
            {school.avgMastery}%
          </div>
          <div className="text-xs text-emerald-600" data-id="element-7833" data-mp="3351efqnpua58">Gem. beheersing</div>
        </div>
      </div>

      {school.teachers.length > 0 && <div data-id="element-7834" data-mp="2ydjen5xfiflu">
          <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-7835" data-mp="2yd9pfkk7kch7">Docenten</h3>
          <div className="space-y-1" data-id="element-7836" data-mp="2tfq6i7ckfbix">
            {school.teachers.map(t => <div key={t.id} className="flex items-center gap-2 py-1.5" data-id="element-7837" data-mp="2tdds2460njam">
                <Avatar name={t.name} data-id="element-7838" data-mp="2ohgdo3ebcn0h" />
                <span className="text-sm text-gray-700" data-id="element-7839" data-mp="2kes3nsdv5a1x">{t.name}</span>
              </div>)}
          </div>
        </div>}

      {school.learners.length > 0 && <div data-id="element-7840" data-mp="2ffyziqkguvef">
          <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-7841" data-mp="2ffp5mrwaw43g">
            Leerlingen
          </h3>
          <div className="space-y-2" data-id="element-7842" data-mp="2aigql06g8g6f">
            {school.learners.map(learner => <div key={learner.id} className="flex items-center justify-between py-2 border-b border-gray-50 last:border-0" data-id="element-7843" data-mp="dmrd6x6frdj1">
            
                <div className="flex items-center gap-2" data-id="element-7844" data-mp="8n68050oa8xv">
                  <Avatar name={learner.name} data-id="element-7845" data-mp="234fvj3zwh8gr" />
                  <div data-id="element-7846" data-mp="27vxu5legawyk">
                    <div className="text-sm text-gray-800" data-id="element-7847" data-mp="27w671dakq29r">{learner.name}</div>
                    <div className="text-xs text-gray-400" data-id="element-7848" data-mp="1t7a0xls2uzbs">
                      {learner.account && 'grade' in learner.account ? `Groep ${learner.account.grade}` : '—'}{' '}
                      · {learner.sessionCount} sessies
                    </div>
                  </div>
                </div>
                <MasteryBar value={learner.avgMastery || 0} data-id="element-7849" data-mp="2quigl05ede5v" />
              </div>)}
          </div>
        </div>}
    </div>;
}